import api from './api';

const projectTypeMasterService = {
  // Get all project type masters with pagination and filters
  getAllProjectTypeMasters: async (params = {}) => {
    try {
      const queryParams = new URLSearchParams();
      
      // Add pagination parameters
      if (params.page) queryParams.append('page', params.page);
      if (params.limit) queryParams.append('limit', params.limit);
      
      // Add filter parameters
      if (params.search) queryParams.append('search', params.search);
      if (params.status) queryParams.append('status', params.status);
      if (params.category) queryParams.append('category', params.category);
      
      const response = await api.get(`/project-type-masters?${queryParams.toString()}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching project type masters:', error);
      throw error;
    }
  },

  // Get project type master by ID
  getProjectTypeMasterById: async (id) => {
    try {
      const response = await api.get(`/project-type-masters/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching project type master:', error);
      throw error;
    }
  },

  // Create new project type master
  createProjectTypeMaster: async (projectTypeMasterData) => {
    try {
      const response = await api.post('/project-type-masters', projectTypeMasterData);
      return response.data;
    } catch (error) {
      console.error('Error creating project type master:', error);
      throw error;
    }
  },

  // Update project type master
  updateProjectTypeMaster: async (id, projectTypeMasterData) => {
    try {
      const response = await api.put(`/project-type-masters/${id}`, projectTypeMasterData);
      return response.data;
    } catch (error) {
      console.error('Error updating project type master:', error);
      throw error;
    }
  },

  // Delete project type master (soft delete)
  deleteProjectTypeMaster: async (id) => {
    try {
      const response = await api.delete(`/project-type-masters/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting project type master:', error);
      throw error;
    }
  },

  // Get project type master statistics
  getProjectTypeMasterStats: async () => {
    try {
      const response = await api.get('/project-type-masters/stats');
      return response.data;
    } catch (error) {
      console.error('Error fetching project type master stats:', error);
      throw error;
    }
  }
};

export default projectTypeMasterService;
